import { render, staticRenderFns } from "./EcommQuickActions.vue?vue&type=template&id=69620494&scoped=true"
import script from "./EcommQuickActions.vue?vue&type=script&lang=js"
export * from "./EcommQuickActions.vue?vue&type=script&lang=js"
import style0 from "./EcommQuickActions.vue?vue&type=style&index=0&id=69620494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69620494",
  null
  
)

export default component.exports